import React, { Component } from "react";
import IOnGetVendorDTO from "../../../models/DTO/IOnGetVendorDTO";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import IDeleteVendorAddressDTO from "../../../models/DTO/IDeleteVendorAddressDTO";
import OwTable from "../../shared/OwTable/OwTable";
import IAddress from "../../../models/IAddress";
import IOnGetVendorAddressesDTO from "../../../models/DTO/IOnGetVendorAddressesDTO";
import IGetVendorDTO from "../../../models/DTO/IGetVendorDTO";
import IOwTableCols from "../../../models/IOwTableCols";
import OwButton from "../../shared/OwButton/OwButton";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import OwLabel from "../../shared/OwLabel/OwLabel";
import INotification from "../../../models/INotification";
import ISupplierModel from "../../../models/ISupplierModel";
import IVendorModel from "../../../models/IVendorModel";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import IGetVendorAddressesDTO from "../../../models/DTO/IGetVendorAddressesDTO";
import { EditAddressSidebar } from "../../shared/EditAddressSidebar/EditAddressSidebar";
import IOnDeleteVendorAddressDTO from "../../../models/DTO/IOnDeleteVendorAddressDTO";
import OwTitle from "../../shared/OwTitle/OwTitle";
import IUserUI from "../../../models/IUserUI";
import { Socket } from "socket.io-client";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";

type Props = {
    socket: Socket;
    setActivityIndicator: (activityIndicator: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    history: any;
    location: any;
    match: any;
};

type State = {
    vendorGuid: string;
    breadcrumbs: IBreadcrumbs[];
    vendorModel?: IVendorModel;
    addresses: IAddress[];
    columns: IOwTableCols[];
    isDataFetching: boolean;
    isInitialData: boolean;
    offset: number;
    limit: number;
    totalRecords: number;
    sourceElement: string | null;
};

class SupplierVendorAddresses extends Component<Props, State> {
    assignOverlayRef: any;
    deleteIndex: any;

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        this.state = {
            vendorGuid: this.props.match.params.guid,
            breadcrumbs: [
                { title: "dashboard", url: "/dashboard" },
                { title: "vendors", url: "/vendors", isVendorNameOverride: true },
            ],
            addresses: [],
            columns: [
                {
                    title: "",
                    valueProp: "",
                    renderFn: this.renderActions,
                    renderFnEmitsRow: true,
                    className: "w-3r",
                },
                {
                    title: "catalog_price_group_default_address",
                    valueProp: "",
                    renderFn: this.renderCatalogPriceGroupLock,
                    renderFnEmitsRow: true,
                    className: "w-13r",
                },
                {
                    title: "detail",
                    valueProp: "",
                    renderFn: this.renderAddressBlock,
                    renderFnEmitsRow: true,
                    className: "w-15r",
                },
                {
                    title: "map",
                    valueProp: "",
                    renderFn: this.renderStaticMap,
                    renderFnEmitsRow: true,
                },
            ],
            isDataFetching: true,
            isInitialData: true,
            offset: 0,
            limit: 10,
            totalRecords: 0,
            sourceElement: null,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.VendorsOnGetVendor, fn: this.onGetVendor },
            { endpoint: EndpointsEnum.AddressOnGetVendorAddresses, fn: this.onGetVendorAddresses },
            { endpoint: EndpointsEnum.AddressOnDeleteVendorAddress, fn: this.onDeleteVendorAddress },
        ];
    }

    componentDidMount() {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        this.getVendor();
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    toggleConfirmDelete = (e: any, data: any, index: number) => {
        this.deleteIndex = index;

        this.setState({
            sourceElement: `row-${index}`,
        });
    };

    renderActions = (row: IAddress, index: number) => {
        return (
            <div className={"d-flex"}>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={(e: any) => {
                        this.toggleConfirmDelete(e, row, index);
                    }}
                    onEditClickFn={() => {
                        this.openSidebar(row);
                    }}
                />
            </div>
        );
    };

    renderStaticMap = (row: IAddress) => {
        if (this.props.supplierModel.has_google_maps) {
            return <OwGoogleStaticMap address={row} />;
        } else {
            return null;
        }
    };

    renderAddressBlock = (row: IAddress) => {
        return (
            <div>
                {row.is_vendor_main_ship_to ? (
                    <div>
                        <OwLabel title={"default_ship_to"} isBold={true} className={"text-primary"} />
                    </div>
                ) : null}
                <AddressDisplay address={row} showCompanyName={true} showName={true} showPhone={true} hideMobile={true} />
                {row.address_internal_id ? <div className={"mt-2 text-muted"}>{row.address_internal_id}</div> : null}
                {this.props.userModel.isSupplierUser &&
                this.props.supplierModel.has_sales_tax &&
                !this.props.supplierModel.Supplier_Integration?.has_taxjar &&
                row.tax_rate_override ? (
                    <div className={"mt-2"}>
                        <OwLabel className={"me-2"} title={"tax_rate_override"} postText={":"} noBottomMargin={true} />
                        {Math.round(row.tax_rate_override * 10000) / 100}%
                    </div>
                ) : null}
            </div>
        );
    };

    renderCatalogPriceGroupLock = (row: IAddress) => {
        const catalog = row.Catalog?.name || "";
        const price_group = row.Price_Group?.value || "";

        return `${catalog}` + (price_group.length ? ` - ${price_group}` : "");
    };

    getVendor = () => {
        const payload: IGetVendorDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.vendorGuid,
        };

        this.props.socket.emit("getVendor", payload);
    };

    onGetVendor = (data: IOnGetVendorDTO) => {
        const breadcrumbs = [...this.state.breadcrumbs];

        if (this.state.breadcrumbs.length < 3) {
            breadcrumbs.push({ title: `${data.vendor.name} Addresses`, url: "", skipTranslate: true });
        }

        this.setState(
            {
                vendorModel: data.vendor,
                breadcrumbs,
            },
            () => {
                this.getVendorAddresses();
            }
        );
    };

    getVendorAddresses = () => {
        const payload: IGetVendorAddressesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.vendorGuid,
            onlyNonAssignedAddresses: true,
            limit: this.state.limit,
            offset: this.state.offset,
        };

        this.props.socket.emit("getVendorAddresses", payload);

        this.setState({
            isDataFetching: true,
        });
    };

    onGetVendorAddresses = (data: IOnGetVendorAddressesDTO) => {
        this.setState({
            addresses: data.addresses,
            isDataFetching: false,
            isInitialData: false,
            totalRecords: data.totalRecords,
        });
    };

    openSidebar = (address?: IAddress) => {
        const sidebarComponent = (
            <EditAddressSidebar address={address} cancel={this.cancelSidebar} showInternalId={true} vendorGuid={this.state.vendorGuid} />
        );

        this.props.setSidebarComponent(sidebarComponent);
        this.props.toggleSidebar(true);
    };

    cancelSidebar = (refreshData?: boolean) => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);

        if (refreshData) {
            this.getVendorAddresses();
        }
    };

    paginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getVendorAddresses();
            }
        );
    };

    cancelDelete = () => {
        this.setState({
            sourceElement: null,
        });
    };

    commitAddressDelete = () => {
        const address = this.state.addresses[this.deleteIndex];

        const payload: IDeleteVendorAddressDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.vendorGuid,
            addressId: address.id,
        };

        this.props.socket.emit("deleteVendorAddress", payload);

        this.deleteIndex = undefined;

        this.setState({
            sourceElement: null,
        });
    };

    onDeleteVendorAddress = (data: IOnDeleteVendorAddressDTO) => {
        this.getVendorAddresses();
    };

    render() {
        return (
            <div className="SupplierVendorAddresses">
                <Breadcrumbs crumbs={this.state.breadcrumbs} supplierModel={this.props.supplierModel} />

                <div className={"d-flex align-items-center mt-1"}>
                    <OwTitle title={"addresses"} leftIconName={"fad fa-building"} className={"me-2"} />

                    <div>
                        <OwButton
                            title={"create"}
                            leftIconClass={"far fa-plus"}
                            fn={() => {
                                this.openSidebar();
                            }}
                        />
                    </div>
                </div>

                <div className={"position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={this.state.sourceElement}
                        message={"confirm_delete_address"}
                        handleConfirm={this.commitAddressDelete}
                        handleCancel={this.cancelDelete}
                        nestedParentElem={"account-addresses"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"account-addresses"}
                        columns={this.state.columns}
                        dataSet={this.state.addresses}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.isDataFetching}
                        initialData={this.state.isInitialData}
                        tableConfig={{ tableStriped: true }}
                    />
                </div>

                <div>
                    <PaginationBar
                        offset={this.state.offset}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        onPaginationChanged={this.paginationChanged}
                    />
                </div>
            </div>
        );
    }
}

export default SupplierVendorAddresses;
